import { createReducer } from "../../common/reduxUtil";
import { makeSearchId } from "../common/searchAnalytics";
import {
  RESET_SEARCH_BAR,
  RESET_SEARCH_RESULTS,
  SET_COMMUNITIES,
  SET_IS_NAV_SEARCH_BAR_IN_FOCUS,
  SET_IS_BANNER_SEARCH_BAR_IN_FOCUS,
  SET_LISTED_JOBS,
  SET_ORGANIZATION,
  SET_QUERY,
  SET_QUESTS,
  SET_SEARCH_BAR_RESULTS,
  SET_SKYLIFTS,
  SET_USERS,
  SET_MENTORS,
} from "./types";

const initialState = {
  query: "",
  // Analytics join key: minted whenever a non-empty query is set.
  searchId: "",
  searchBarSearchId: "",
  questIds: null,
  quests: null,
  skylifts: null,
  communities: null,
  users: null,
  mentors: null,
  isNavSearchBarInFocus: false,
  isBannerSearchBarInFocus: false,
  searchBarResults: null,
};

export default createReducer(initialState, {
  [SET_QUERY]: (state, payload) => {
    return Object.assign({}, state, {
      query: payload.query,
      searchId: payload.query ? makeSearchId() : "",
    });
  },
  [SET_QUESTS]: (state, payload) => {
    const prevQuestIds = state.questIds ? new Set(state.questIds) : new Set();
    const prevQuests = state.quests ? [...state.quests] : [];
    const prevQuestsLength = prevQuests.length;

    for (const quest of payload.quests) {
      const questId = quest._id;

      if (!prevQuestIds.has(questId)) {
        prevQuests.push(quest);
        prevQuestIds.add(questId);
      }
    }

    // This is a workaround to update the quests' Array length so that our
    // Infinite Scroll component makes further calls.
    if (prevQuestsLength !== 0 && prevQuestsLength === prevQuests.length) {
      prevQuests.push(null);
    }

    return Object.assign({}, state, {
      quests: prevQuests,
      questIds: [...prevQuestIds],
    });
  },
  [SET_SKYLIFTS]: (state, payload) => {
    const prev = state.skylifts ? [...state.skylifts] : [];
    return Object.assign({}, state, {
      skylifts: prev.concat(payload.skylifts),
    });
  },
  [SET_COMMUNITIES]: (state, payload) => {
    const prev = state.communities ? [...state.communities] : [];
    return Object.assign({}, state, {
      communities: prev.concat(payload.communities),
    });
  },
  [SET_ORGANIZATION]: (state, payload) => {
    const prev = state.organizations ? [...state.organizations] : [];
    return Object.assign({}, state, {
      organizations: prev.concat(payload.organizations),
    });
  },
  [SET_LISTED_JOBS]: (state, payload) => {
    const prev = state.listedJobs ? [...state.listedJobs] : [];
    return Object.assign({}, state, {
      listedJobs: prev.concat(payload.listedJobs),
    });
  },
  [SET_USERS]: (state, payload) => {
    const prev = state.users ? [...state.users] : [];
    return Object.assign({}, state, {
      users: prev.concat(payload.users),
    });
  },
  [SET_MENTORS]: (state, payload) => {
    const prev = state.mentors ? [...state.mentors] : [];
    return Object.assign({}, state, {
      mentors: prev.concat(payload.mentors),
    });
  },
  [RESET_SEARCH_RESULTS]: (state) => {
    return Object.assign({}, state, {
      questIds: null,
      quests: null,
      skylifts: null,
      communities: null,
      users: null,
      mentors: null,
      organizations: null,
      listedJobs: null,
    });
  },
  [SET_IS_NAV_SEARCH_BAR_IN_FOCUS]: (state, payload) => {
    return Object.assign({}, state, {
      isNavSearchBarInFocus: payload.isInFocus,
    });
  },
  [SET_IS_BANNER_SEARCH_BAR_IN_FOCUS]: (state, payload) => {
    return Object.assign({}, state, {
      isBannerSearchBarInFocus: payload.isInFocus,
    });
  },
  [SET_SEARCH_BAR_RESULTS]: (state, payload) => {
    return Object.assign({}, state, {
      searchBarResults: payload.searchBarResults,
      searchBarSearchId: payload.searchId ?? state.searchBarSearchId,
    });
  },
  [RESET_SEARCH_BAR]: (state) => {
    return Object.assign({}, state, {
      searchBarResults: null,
      isNavSearchBarInFocus: false,
      isBannerSearchBarInFocus: false,
    });
  },
});
